module.exports = __webpack_public_path__ + "img/icon5.cf48d1f2.png";